// PhysicalDocumentToggle.jsx
import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import YesNoToggle from "../../YesNoToggle/YesNoToggle"; // Adjust the path as necessary

const PhysicalDocumentToggle = ({ checked, disabled = false, onChange, onViewClick }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      justifyContent: "center",
    }}
  >
    <div>
      <YesNoToggle
        checked={checked}
        onChange={onChange}
        name="physicalDocumentReceived"
        inputProps={{ "aria-label": "secondary checkbox" }}
        disabled={disabled}
      />
      {( checked && onViewClick) && (
        <Button
          variant="text"
          style={{
            color: "#3f51b5",
            textTransform: "none",
            fontSize: "0.875rem",
            marginLeft: "8px",
          }}
          onClick={onViewClick}
        >
          View
        </Button>
      )}
    </div>
  </div>
);

export default PhysicalDocumentToggle;

PhysicalDocumentToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onViewClick: PropTypes.func.isRequired,
};
